export default [
    {
        path: "/flowDirection",
        name: "流向查询",
        component: () => import("@/pages/flowDirection/flowDirection.vue"),
        icon: "none",
        meta: {
            comName: "flowDirection",
            needRefresh: true
        }
    },
    {
        path: '/flow/netplatform',
        name: '挂网报告',
        component: () => import('@/pages/flowDirection/netPlatoform'),
        icon: 'none'
    }
];



// WEBPACK FOOTER //
// ./src/router/flowDirection.js